import {Injectable} from "@angular/core";
import {UserTypeEnum} from "../enums/user-type.enum";
import {SharedToolsService} from "../services/shared-tools.service";

@Injectable({
	providedIn: 'root'
})
export class ProductsHelper {
	token: any = JSON.parse(localStorage.getItem("token")!);
	nameJson: any = "txtProduits";
	textes: any = "";

	constructor(
		private sharedToolsService: SharedToolsService
	) {
		// Load the texts
		this.sharedToolsService.loadTexts(this.nameJson)
			.subscribe(textes => {
				this.textes = textes;
			});
	}

	getProductTexts(productName: string, field: string) {
		let userType: UserTypeEnum = this.token?.usrType;
		let productLabel: string = "";
		let productText: string = "";
		let productBottomText: string = "";

		switch (userType) {
			case UserTypeEnum.PARTICULIER:
				if (productName.toLowerCase().indexOf("pack") != -1) {
					productText = this.textes.labelOffrePackParticulier;
					productLabel = productName;
					productBottomText = this.textes.labelOffrePackBottomText;
				} else if (productName.toLowerCase().indexOf("agent") != -1) {
					productText = this.textes.labelOffreIllimiteParticulier;
					productLabel = productName.replace(this.textes.labelOffrePackParamAgent, this.textes.labelOffrePackParamParticulier);
					productBottomText = this.textes.labelOffreIllimiteBottomText;
				} else {
					productText = "";
					productLabel = productName;
				}
				break;
			case UserTypeEnum.AGENT_MANDATAIRE:
				if (productName.toLowerCase().indexOf("pack") != -1) {
					productText = this.textes.labelOffrePackAgent;
					productLabel = productName;
					productBottomText = this.textes.labelOffrePackBottomText;
				} else if (productName.toLowerCase().indexOf("agent") != -1) {
					productText = this.textes.labelOffreIllimiteAgent;
					productBottomText = this.textes.labelOffreIllimiteBottomText;
					productLabel = productName + ' ' + this.textes.labelOffrePackParamAgent2;
				} else {
					productText = "";
					productLabel = productName;
				}
				break;
			case UserTypeEnum.AGENCE_VITRINE:
				if (productName.toLowerCase().indexOf("pack") != -1) {
					productText = this.textes.labelOffrePackAgent;
					productLabel = productName;
					productBottomText = this.textes.labelOffrePackBottomText;
				} else if (productName.toLowerCase().indexOf("agences") != -1) {
					productText = this.textes.labelOffreIllimiteAgence;
					productLabel = productName;
					productBottomText = this.textes.labelOffreIllimiteBottomText;
				} else {
					productText = "";
					productLabel = productName;
				}
				break;
			case UserTypeEnum.ENTREPRISE_BATIMENT:
				if (productName.toLowerCase().indexOf("pack") != -1) {
					productText = this.textes.labelOffrePackEnt;
					productLabel = productName;
					productBottomText = this.textes.labelOffrePackBottomText;
				} else if (productName.toLowerCase().indexOf("agences") != -1) {
					productText = this.textes.labelOffreIllimiteEnt;
					productLabel = productName.replace(this.textes.labelOffrePackParamAgence, this.textes.labelOffrePackParamEnt);
					productBottomText = this.textes.labelOffreIllimiteBottomText;
				} else {
					productText = "";
					productLabel = productName;
				}
				break;
			default:
				break;
		}

		return (field == "label") ? productLabel : (field == "text") ? productText : productBottomText;
	}
}
